module.exports = __webpack_public_path__ + "img/111.0c20c1d9.png";